import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Card, Badge } from "../../components/ui/Card";
import Input from "../../components/ui/Input";

export default function Emails() {
  const [emails, setEmails] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = (params = {}) =>
    api
      .get("/admin/email-logs", { params })
      .then(({ data }) => setEmails(data.data || []))
      .catch(() => setEmails([]))
      .finally(() => setLoading(false));

  useEffect(() => {
    load();
  }, []);

  return (
    <div>
      <h1 className="mb-1 font-montserrat text-2xl font-bold text-slate-900">Sent emails</h1>
      <p className="mb-4 text-sm text-muted-foreground">Every email SHUWA has sent, newest first.</p>
      <Input
        placeholder="Search by email or subject…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && load({ q })}
        className="mb-4 w-full sm:max-w-sm"
      />

      {loading ? (
        <p className="text-muted-foreground">Loading…</p>
      ) : (
        <div className="space-y-2">
          {emails.map((m) => (
            <Card key={m.id} className="flex flex-wrap items-center justify-between gap-3 p-4">
              <div className="min-w-0">
                <p className="font-semibold text-slate-900 break-words">{m.subject}</p>
                <p className="text-xs text-muted-foreground break-words">
                  {m.recipient}
                  {m.user ? ` · ${m.user.full_name}` : ""}
                </p>
              </div>
              <div className="flex items-center gap-2">
                {m.user && <Badge>{m.user.role}</Badge>}
                <span className="text-xs text-muted-foreground">{new Date(m.sent_at).toLocaleString()}</span>
              </div>
            </Card>
          ))}
          {emails.length === 0 && <p className="text-muted-foreground">No emails found.</p>}
        </div>
      )}
    </div>
  );
}
